





































































import {
  Component,
  Prop,
  Vue, Watch,
} from 'vue-property-decorator';
import Dialog from '../components/Dialog.vue';
import {Job} from '@/types';
import JobsService from '@/services/jobs.service';
import Table from '@/components/Table.vue';
import SearchBar from '@/components/SearchBar.vue';
import { Getter } from 'vuex-class';
import { copyToClipboard } from '@/classes/utils';

@Component({
  components: {SearchBar, Table, Dialog},
})
export default class JobHistory extends Vue {
  @Prop() private showDialog!: boolean;
  @Getter private projectById!: any;
  @Getter private activeAccountId!: any;
  @Getter private hasPermission: any;

  private jobs: Job[] = [];
  private headers: any[] = [
    { text: 'Created', value: 'created_at', sortable: false },
    { text: 'File name', value: 'filename', sortable: false },
    { text: 'Status', value: 'status', sortable: false },
    { text: 'Type', value: 'type', sortable: false },
    { text: 'Project', value: 'project_id', sortable: false },
    { text: 'Rows', value: 'rows', sortable: false },
    { text: 'Processed', value: 'processed', sortable: false },
    { text: 'Skipped', value: 'skipped', sortable: false },
    { text: 'Errors', value: 'errors', sortable: false },
  ];

  private copyToClipboard: (text: string) => boolean = copyToClipboard;

  private async mounted() {
    const jobsPromise = JobsService.getJobs();
    const promises: Array<Promise<Job[]>> = [jobsPromise];

    if (this.hasPermission('account:view') && this.activeAccountId) {
     promises.push(JobsService.getAccountJobs(this.activeAccountId));
    }
    if (this.hasPermission('administration:view')) {
      promises.push(JobsService.getAdminJobs());
    }

    const results = await Promise.all(promises);
    const combinedJobs = results.flat();


    Vue.set(this, 'jobs', combinedJobs);
  }

  private customSort(items: any[]) {
    return items.sort((a, b) => - a.created_at.localeCompare(b.created_at));
  }

  private getType(item: any) {
    switch (item.type) {
      case 'location_import': return 'Import: Location';
      case 'device_import': return 'Import: Device';
      case 'location_export': return 'Export: Locations';
      case 'device_export': return 'Export: Devices';
      case 'data_export': return 'Export: Data';
      case 'admin_subscription_export': return 'Export: Admin subscriptions';
      case 'subscription_export':
        return item.account_id ? 'Export: Account subscriptions' : 'Export: Subscriptions';
      case 'devices_assign': return 'Assign: Devices';
      case 'device_subscribe': return 'Subscribe: Devices';
      case 'configuration_profile_assign': return 'Assign: Configuration profile';
      case 'devices_transfer': return 'Transfer: Devices';
      case 'subscriptions_transfer': return 'Transfer: Subscriptions';
      default: return 'Import';
    }
  }

  private getStatusColor(status: string) {
    switch (status) {
      case 'completed': return 'green--text';
      case 'running': return 'primary--text';
      case 'failed': return 'red--text';
      default: return 'default--text';
    }
  }

  private getErrors(errors: string[]) {
    if (errors && errors.length > 0) {
      return {
        first_error: errors[0],
        additional_errors: errors.length > 1 ? errors.length - 1 : 0,
      };
    }
  }

  private stringifyErrors(errors: string[]) {
    if (errors && errors.length) {
      return JSON.stringify(errors);
    }
    return '';
  }
}
